<h2>
    <div class="left-titl-buton ">
        <div class="title">
           <span *ngIf="data.type === 'Success'">Success</span>
           <span *ngIf="data.type === 'Error'">Error</span>
        </div>
        <button class="cancel-button" (click)="onClose()">&times;</button>
    </div></h2>
<!-- <h1 mat-dialog-title>Success</h1>
<button class="cancel-button" (click)="onClose()">&times;</button> -->
<div mat-dialog-content class="auth-dialog">
  <!-- <p>Your request has been submitted.</p>
  <p>AI-Advisor request for EP</p> -->
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>

</div>